import { Outlet } from 'react-router-dom'

import BuyerHeader from "../components/buyer/Header/BuyerHeader"

function Layout() {
  return (
    <div>
      <BuyerHeader />
      <div style={{ paddingTop: "15vh" }}>
        <Outlet />
      </div>
    </div>
  )
}

export default Layout